import querystring from 'querystring';
import api from '../../api';

class DataServiceLooker {

    addAllEnrollments() {
        return api.put('/reports/looker-update-rows');
    }

    addAllComments() {
        return api.put('/reports/looker-update-rows-comment');
    }

    addAllRatings() {
        return api.put('/reports/looker-update-rows-ratings');
    }

    addAllFeedback() {
        return api.put('/reports/looker-update-rows-feedback');
    }

    addAllEnrollmentsFull() {
        return api.put('/reports/looker-update-rows-full');
    }

    addAllLastProgress() {
        return api.put('/reports/looker-update-rows-progress');
    }

    addAllCompanies() {
        return api.put('/reports/looker-update-rows-companies');
    }

    getCompanyReports() {
        return api.get('/reports/looker-company-reports');
    }

    updateCompanyAcademic(id_company) {
        return api.put('/reports/looker-update-rows-company-academic', { id_company });
    }

    updateCompanyTrails(id_company) {
        return api.put('/reports/looker-update-rows-company-trails', { id_company });
    }

    updateCompanyUsers(id_company) {
        return api.put('/reports/looker-update-rows-company-users', { id_company });
    }

}

export default new DataServiceLooker();
